import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../context/AuthContext';
import './Navbar.scss';
import logo from '../assets/logo.png'; // Import logo from assets

const Navbar: React.FC = () => {
  const { user, userProfile } = useAuth();
  const location = useLocation();

  return (
    <motion.nav 
      className="navbar"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
    >
      <div className="navbar-container">
        {/* Logo */}
        <Link to="/dashboard" className="navbar-logo">
          <img src={logo} alt="Logo" style={{ height: '90px', width: '123px' , position: 'absolute', margin: '-1rem', top: '0.6rem'}} />
        </Link>

        {/* Navigation Links - Only show when authenticated */}
        {user && (
          <div className="navbar-nav">
            <Link 
              to="/dashboard" 
              className={`nav-link ${location.pathname === '/dashboard' ? 'active' : ''}`}
            >
              Dashboard
            </Link>
            <Link 
              to="/quizzes" 
              className={`nav-link ${location.pathname === '/quizzes' ? 'active' : ''}`}
            >
              Quizzes
            </Link>
            <Link 
              to="/games" 
              className={`nav-link ${location.pathname === '/games' ? 'active' : ''}`}
            >
              Games
            </Link>
            <Link 
              to="/missions" 
              className={`nav-link ${location.pathname === '/missions' ? 'active' : ''}`}
            >
              Missions
            </Link>
            <Link 
              to="/leaderboard" 
              className={`nav-link ${location.pathname === '/leaderboard' ? 'active' : ''}`}
            >
              Leaderboard
            </Link>
            <Link 
              to="/eco-coins" 
              className={`nav-link ${location.pathname === '/eco-coins' ? 'active' : ''}`}
            >
              EcoCoins
            </Link>
          </div>
        )}

        {/* User Section */}
        <div className="navbar-user">
          {user && userProfile ? (
            <div className="user-info">
              <div className="user-avatar">
                {userProfile.photoURL ? (
                  <img src={userProfile.photoURL} alt={userProfile.displayName} />
                ) : (
                  <span>{userProfile.displayName.charAt(0).toUpperCase()}</span>
                )}
              </div>
              <div className="user-details">
                <span className="user-name">{userProfile.displayName}</span>
                <span className="user-role">{userProfile.role}</span>
              </div>
            </div>
          ) : (
            <div className="auth-links">
              <Link to="/login" className="btn btn--ghost">
                Login
              </Link>
              <Link to="/signup" className="btn btn--primary">
                Sign Up
              </Link>
            </div>
          )}
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;
